export default __webpack_public_path__ + "images/17_1_image.jpg";